import {useCache} from "~/common/useCache";

export default defineNuxtPlugin((nuxtApp) => {
  const { setupAutoTracking } = useAnalytics()
  const app = useAppStore()
  if (app.user !== null) {
    setupAutoTracking()
  }
  /*  const { gtag } = useGtag()
    // 페이지 이동 추적
    nuxtApp.vueApp.directive('track-click', {
      mounted(el, binding) {
        el.addEventListener('click', () => {
          const eventName = binding.value?.event || 'button_click'
          const eventParams = {
            button_name: binding.value?.name || el.innerText || 'unnamed button',
            ...binding.value?.params
          }

          // GA4 이벤트 발송
          gtag('event', eventName, eventParams)
        })
      }
    })

    // 페이지 변경 감지
    nuxtApp.hook('page:finish', () => {
      gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname
      })
    })*/
})
